import {
    UI_RESET,
    UI_BUSY,
    UI_TITLE,
    UI_SUBTITLE,
    UI_HEADERCLASS,
    UI_FOOTERCLASS,
    UI_BODYCLASS,
    UI_SHOW_PAGE_HEADER,
    UI_SHOW_PAGE_FOOTER,
    UI_INIT_I18N,
    UI_I18N_LANG,
    UI_I18N_LANGS,
    UI_LOGO_LANG,
    UI_I18N_COUNTRIES,
    UI_I18N_CURRENCIES,
    UI_I18N_EINHEITENSYSTEME,
    UI_USER,
    UI_MESSAGE,
    UI_MESSAGES,
    UI_USERLIST_MODE,
    UI_USERLIST_FILTER,
    UiActionTypes,
} from "./actiontypes";

import { ParamasterUser } from './types';
import { Kode4GrowlMessage } from "@kode4/ui";

export function uiReset(): UiActionTypes {
    return {
        type: UI_RESET,
    }
}

export function uiBusy(busy: boolean): UiActionTypes {
    return {
        type: UI_BUSY,
        busy
    }
}

export function uiTitle(title: string): UiActionTypes {
    return {
        type: UI_TITLE,
        title
    }
}

export function uiSubTitle(subTitle: string): UiActionTypes {
    return {
        type: UI_SUBTITLE,
        subTitle
    }
}

export function uiHeaderClass(cssClass: string): UiActionTypes {
    return {
        type: UI_HEADERCLASS,
        cssClass
    }
}

export function uiFooterClass(cssClass: string): UiActionTypes {
    return {
        type: UI_FOOTERCLASS,
        cssClass
    }
}

export function uiBodyClass(cssClass: string): UiActionTypes {
    return {
        type: UI_BODYCLASS,
        cssClass
    }
}

export function uiShowPageHeader(show: boolean): UiActionTypes {
    return {
        type: UI_SHOW_PAGE_HEADER,
        show
    }
}

export function uiShowPageFooter(show: boolean): UiActionTypes {
    return {
        type: UI_SHOW_PAGE_FOOTER,
        show
    }
}

export function uiInitI18n(initialized: boolean): UiActionTypes {
    return {
        type: UI_INIT_I18N,
        initialized
    }
}

export function uiI18nLang(lang: string): UiActionTypes {
    return {
        type: UI_I18N_LANG,
        lang
    }
}

export function uiI18nLangs(langs: Array<string>): UiActionTypes {
    return {
        type: UI_I18N_LANGS,
        langs
    }
}

export function uiLogoLang(logoLang: string): UiActionTypes {
    return {
        type: UI_LOGO_LANG,
        logoLang
    }
}

export function uiI18nCountries(countries: Array<string>): UiActionTypes {
    return {
        type: UI_I18N_COUNTRIES,
        countries
    }
}

export function uiI18nCurrencies(currencies: Array<string>): UiActionTypes {
    return {
        type: UI_I18N_CURRENCIES,
        currencies
    }
}

export function uiI18nEinheitensysteme(einheitensysteme: Map<number, string>): UiActionTypes {
    return {
        type: UI_I18N_EINHEITENSYSTEME,
        einheitensysteme
    }
}

export function uiUser(user?: ParamasterUser): UiActionTypes {
    return {
        type: UI_USER,
        user
    }
}

export function uiMessage(message: Kode4GrowlMessage): UiActionTypes {
    return {
        type: UI_MESSAGE,
        message
    }
}

export function uiMessages(messages: Array<Kode4GrowlMessage>): UiActionTypes {
    return {
        type: UI_MESSAGES,
        messages
    }
}

export function uiUserlistMode(mode: string): UiActionTypes {
    return {
        type: UI_USERLIST_MODE,
        mode
    }
}

export function uiUserlistFilter(filter: string): UiActionTypes {
    return {
        type: UI_USERLIST_FILTER,
        filter
    }
}
